var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5038 16.7644C14.2962 17.7031 12.779 18.262 11.131 18.262C7.19262 18.262 4 15.0694 4 11.131C4 7.19262 7.19262 4 11.131 4C15.0694 4 18.262 7.19262 18.262 11.131C18.262 12.779 17.7031 14.2963 16.7645 15.5038L19.7389 18.4783C20.087 18.8264 20.087 19.3909 19.7389 19.7389C19.3909 20.087 18.8264 20.087 18.4784 19.7389L15.5038 16.7644ZM16.4793 11.131C16.4793 14.0848 14.0848 16.4793 11.131 16.4793C8.17725 16.4793 5.78276 14.0848 5.78276 11.131C5.78276 8.17725 8.17725 5.78276 11.131 5.78276C14.0848 5.78276 16.4793 8.17725 16.4793 11.131Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.878d07727a1464117bdd49d3a5a091d8.svg";